import { GET_COUNTRY_URL, GET_SERVICES_URL, GET_STATE_URL, GET_USER_PROFILE_PHOTO_URL, UPDATE_BILLING_ADDRESS_URL, UPDATE_SIGNUP_BANK_DETAILS, UPDATE_SIGNUP_USER_DETAILS_URL, UPDATE_USER_PROFILE_IMAGE_URL, UPDATE_USER_PROFILE_URL, VIEW_ADDRESS_DETAILS_URL, VIEW_USER_PROFILE_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const viewUserProfile = () => onResponse => {
    try {
        axiosInstance.get(VIEW_USER_PROFILE_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getUserProfilePhoto = (user) => onResponse => {
    try {
        axiosInstance.get(GET_USER_PROFILE_PHOTO_URL + '?user=' + user)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const updateUserProfile = (address_data, user_data, pan_number, primary_service, secondary_service, about_user) => onResponse => {
    try {
        axiosInstance.patch(UPDATE_USER_PROFILE_URL, { address_data, user_data, pan_number, primary_service, secondary_service, about_user })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const updateUserProfileImage = (props) => onResponse => {
    try {
        axiosInstance.post(UPDATE_USER_PROFILE_IMAGE_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const fetchServices = () => onResponse => {
    try {
        axiosInstance.get(GET_SERVICES_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const updateSignUpUserDetails = (props) => onResponse => {
    try {
        axiosInstance.post(UPDATE_SIGNUP_USER_DETAILS_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getUserImage = () => onResponse => {
    try {
        axiosInstance.get(UPDATE_SIGNUP_USER_DETAILS_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const updateBillingAddress = (values) => onResponse => {
    try {
        axiosInstance.post(UPDATE_BILLING_ADDRESS_URL, values)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const updateSignUpBankDetails = (values) => onResponse => {
    try {
        axiosInstance.put(UPDATE_SIGNUP_BANK_DETAILS, values)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getCountryDropdown = () => onResponse => {
    try {
        axiosInstance.get(GET_COUNTRY_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getStateDropdown = (id) => onResponse => {
    try {
        axiosInstance.get(GET_STATE_URL + '?id=' + id)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const viewAddressDetails = () => onResponse => {
    try {
        axiosInstance.get(VIEW_ADDRESS_DETAILS_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};